export default "__VITE_ASSET__Ftb_UxxX__"